export default __webpack_public_path__ + "static/media/corner-dragonfly.dcf4efaf.webp";